"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _methodDescriptor = _interopRequireDefault(require("./method-descriptor"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * @typedef Manifest
 * @param {Object} obj
 *   @param {String} obj.host
 *   @param {Object} obj.gatewayConfigs - default: base values from mappersmith
 *   @param {Object} obj.ignoreGlobalMiddleware - default: false
 *   @param {Object} obj.resources - default: {}
 *   @param {Array}  obj.middleware or obj.middlewares - default: []
 * @param {Object} globalConfigs
 */
function Manifest(obj, _ref) {
  var _ref$gatewayConfigs = _ref.gatewayConfigs,
      gatewayConfigs = _ref$gatewayConfigs === void 0 ? null : _ref$gatewayConfigs,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? [] : _ref$middleware,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context;
  this.host = obj.host;
  this.bodyAttr = obj.bodyAttr;
  this.headersAttr = obj.headersAttr;
  this.authAttr = obj.authAttr;
  this.timeoutAttr = obj.timeoutAttr;
  this.clientId = obj.clientId || null;
  this.gatewayConfigs = (0, _utils.assign)({}, gatewayConfigs, obj.gatewayConfigs);
  this.resources = obj.resources || {};
  this.context = context;
  var clientMiddleware = obj.middleware || obj.middlewares || []; // TODO: deprecate obj.middlewares in favor of obj.middleware

  if (obj.ignoreGlobalMiddleware) {
    this.middleware = clientMiddleware;
  } else {
    this.middleware = _toConsumableArray(clientMiddleware).concat(_toConsumableArray(middleware));
  }
}

Manifest.prototype = {
  eachResource: function eachResource(callback) {
    var _this = this;

    Object.keys(this.resources).forEach(function (resourceName) {
      var methods = _this.eachMethod(resourceName, function (methodName) {
        return {
          name: methodName,
          descriptor: _this.createMethodDescriptor(resourceName, methodName)
        };
      });

      callback(resourceName, methods);
    });
  },
  eachMethod: function eachMethod(resourceName, callback) {
    return Object.keys(this.resources[resourceName]).map(callback);
  },
  createMethodDescriptor: function createMethodDescriptor(resourceName, methodName) {
    var definition = this.resources[resourceName][methodName];

    if (!definition || !definition.path) {
      throw new Error("[Mappersmith] path is undefined for resource \"".concat(resourceName, "\" method \"").concat(methodName, "\""));
    }

    return new _methodDescriptor.default((0, _utils.assign)({
      host: this.host,
      bodyAttr: this.bodyAttr,
      headersAttr: this.headersAttr,
      authAttr: this.authAttr,
      timeoutAttr: this.timeoutAttr
    }, definition));
  },

  /**
   * @param {Object} args
   *   @param {String|Null} args.clientId
   *   @param {String} args.resourceName
   *   @param {String} args.resourceMethod
   *   @param {Object} args.context
   *   @param {Boolean} args.mockRequest
   *
   * @return {Array<Object>}
   */
  createMiddleware: function createMiddleware() {
    var _this2 = this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var createInstance = function createInstance(middlewareFactory) {
      return (0, _utils.assign)({
        __name: middlewareFactory.name || middlewareFactory.toString(),
        response: function response(next) {
          return next();
        },

        /**
         * @since 2.27.0
         * Replaced the request method
         */
        prepareRequest: function prepareRequest(next) {
          var _this3 = this;

          return this.request ? next().then(function (req) {
            return _this3.request(req);
          }) : next();
        }
      }, middlewareFactory((0, _utils.assign)(args, {
        clientId: _this2.clientId,
        context: (0, _utils.assign)({}, _this2.context)
      })));
    };

    return this.middleware.map(createInstance);
  }
};
var _default = Manifest;
exports.default = _default;